export default function validateCreateCurso(values) {
    let errors = {};
  
    // tituloCurso Errors
    if (!values.tituloCurso) {
      errors.tituloCurso = "Titulo de Curso requirido";
    } else if (values.tituloCurso.length < 4) {
      errors.tituloCurso = "Titulo de Curso debe ser por lo menos 4 caracteres";
    }
    if (!values.descripcionCurso) {
      errors.descripcionCurso = "Descripcion de Curso requirido";
    } else if (values.descripcionCurso.length < 4) {
      errors.descripcionCurso = "Descripcion de Curso debe ser por lo menos 4 caracteres";
    }
    if (!values.profesorCurso) {
      errors.profesorCurso = "Nombre de Profesor requirido";
    } else if (values.profesorCurso.length < 4) {
      errors.profesorCurso = "Nombre de Curso debe ser por lo menos 4 caracteres";
    }

    if (!values.imagenCurso) {
      errors.imagenCurso = "Imagen Curso requirido";
    } else if (values.imagenCurso.length < 4) {
      errors.imagenCurso = "Imagen de Curso debe ser por lo menos 4 caracteres";
    }
    // Url Errors
    // if (!values.url) {
    //   errors.url = "URL required";
    // } else if (!/^(ftp|http|https):\/\/[^ "]+$/.test(values.url)) {
    //   errors.url = "URL must be valid";
    // }
  
    return errors;
  }